export const INITIAL_VALUES = {
	password: '',
	password_confirmation: ''
};

export const validate = (values) => {
	let errors = {};

	if (!values.code) {
		errors.code = 'forgot.code_required';
	}

	if (!values.password) {
		errors.password = 'forgot.password_required';
	}

	if (!values.password_confirmation) {
		errors.password_confirmation = 'forgot.password_confirmation_required';
	}
	return errors;
};
